import { Component, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

@Component({
  selector: 'fin-icon-with-text',
  styleUrls: ['./icon-with-text.component.scss'],
  templateUrl: './icon-with-text.component.html',
  standalone: false,
})
export class IconWithTextComponent {
  @Input()
  title$: Observable<string>;
  @Input()
  content$: Observable<string>;
  @Input()
  icons$: Observable<SvgLibraryIcon[]>;
  @Input()
  styleClasses$: Observable<string[]>;
}
